import { Component, ViewChild} from '@angular/core';
import { PaymentMethodSummary } from '../shared/models/payment-method-summary';
import { AppPageComponent } from '../../shared/ui';
import { PaymentsFilterSheetComponent, PaymentsFilter, PaymentMethod, PaymentMethodSummaryService} from '../shared';
import { FormGroup } from '@angular/forms';
import { UserService, Store, StoreHelper } from '../../shared/services';
import { HeaderAction, TopLevelComponent } from '../../shared/models';

@Component({
    template: require('./payment-index.component.pug')
})
export class PaymentIndexComponent extends TopLevelComponent {
    @ViewChild(AppPageComponent) appPage;
    @ViewChild(PaymentsFilterSheetComponent) filterSheet;

    fg = new FormGroup({});

    payments: Array<PaymentMethod>;
    paymentSummary: PaymentMethodSummary;

    private _searchAction = { id: 'search', icon: 'search' };
    private _paymentsFilter: PaymentsFilter;
    private _filterReady: boolean = false;

    public empty = false;
    public pieChartLabels: string[] = ['Total Cash', 'Total External Credit', 'Total Credit Cards', 'Total Checks'];
    public pieChartData: Array<number> = [];
    public pieChartType: string = 'pie';
    pieChartColors: any[] = [{ backgroundColor: ['#E41736', '#00BCD4','#FFEB3B', '#ADADAD'] }];
    public existNumbers: boolean = false;


    public pieChartOptions: any = {
        responsive: true,
        legend: {
            display: false
        }
    };
    constructor(
        private _paymentMethodSummaryService: PaymentMethodSummaryService,
        store: Store,
        storeHelper: StoreHelper,
        userService: UserService
    ) {
        super(store, storeHelper, userService);

        // set title and actions
        this.headerTitle = 'Payment Methods';
        this.headerActions = [this._searchAction];
        this.subscribeToHeaderActions(this._reactToHeaderAction);
    }


    onFilterChanged(filter: PaymentsFilter) {
        this._paymentsFilter = filter;
        this._loadPaymentSaleList();
    }

    private _reactToHeaderAction(action: HeaderAction) {
        if (action.id === this._searchAction.id) {
            this.filterSheet.toggle();
        }
    }

    private _loadPaymentSaleList() {

        let that = this;

        this._UpdatePaymentsFilter();

        if (this._paymentsFilter.locationsSelection.locations.length < 1) {
            this.empty = true;
            if (this.empty) {
                setTimeout(() => this.filterSheet.toggle(), 1500);
            }

            if (this._filterReady) {
                this.filterSheet.toggle();
            }

            this._filterReady = true;

            return;
        }

        this._paymentMethodSummaryService.getPaymentMethodSummary(this._paymentsFilter)
            .subscribe(payments => {
                this.payments = payments;
                this._CalculatePaymentSummary();
                this._LoadPieChart();

                this.empty = !this.existNumbers;

                if (this.empty) {
                    setTimeout(() => this.filterSheet.toggle(), 1500);
                }

                if (this._filterReady) {
                    this.filterSheet.toggle();
                }

                this._filterReady = true;

                that.appPage.deactivatePreloader();
            });
    }

    private _UpdatePaymentsFilter() {

        // If we dont have locations selected, then take all the locations from  the region
        if (this._paymentsFilter.locationsSelection.locations.length < 1) {
            this._paymentsFilter.locationsSelection.locations = this._paymentsFilter.locationsSelection.region.locations;
        }
    }

    private _CalculatePaymentSummary() {
        this.paymentSummary = new PaymentMethodSummary(this.payments);
    }

    private _LoadPieChart() {

        this.existNumbers = this._ValidateExistANumberDifferentZero();

        if (this.existNumbers) {
            this.pieChartData = [];
            this.pieChartData.push(this.paymentSummary.totalCash);
            this.pieChartData.push(this.paymentSummary.totalExternalCredit);
            this.pieChartData.push(this.paymentSummary.totalCreditCards);
            this.pieChartData.push(this.paymentSummary.totalChecks);

        }
    }

    private _ValidateExistANumberDifferentZero(): boolean {

        if (this.paymentSummary.totalCash === 0
            && this.paymentSummary.totalExternalCredit === 0
            && this.paymentSummary.totalCreditCards === 0
            && this.paymentSummary.totalChecks === 0) {
            return false;
        }
        return true;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/accounting/payment/payment-index.component.ts